import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND}/api`;

export const TOKEN_KEY = "kairos_access_token";
const LEGACY_TOKEN_KEY = "lumina_access_token";

// One-time migration from the previous key
try {
  const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
  if (legacy && !localStorage.getItem(TOKEN_KEY)) {
    localStorage.setItem(TOKEN_KEY, legacy);
  }
  if (legacy) localStorage.removeItem(LEGACY_TOKEN_KEY);
} catch {}

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers["Authorization"] = `Bearer ${t}`;
  return config;
});
